var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns" }, [
    _c("div", { staticClass: "background" }),
    _vm._m(0),
    _c("div", { staticClass: "column is-6 is-flex is-centered" }, [
      _c("div", { staticClass: "box" }, [
        _c(
          "form",
          {
            staticClass: "sign-in is-centered",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.onSubmit($event)
              }
            }
          },
          [
            _c("img", { attrs: { src: _vm.logo, alt: "logo" } }),
            _c(
              "h1",
              { staticClass: "title is-4 has-text-izzi-robins-egg-blue" },
              [_vm._v("\n          factura electrónica\n        ")]
            ),
            _vm._m(1),
            _c("AppInputEmail", {
              attrs: {
                value: _vm.email,
                loading: _vm.loading,
                disabled: _vm.loading,
                required: true
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            }),
            _c("AppInputPassword", {
              attrs: {
                value: _vm.password,
                loading: _vm.loading,
                disabled: _vm.loading,
                required: true
              },
              on: { input: _vm.onChange, change: _vm.onChange }
            }),
            _c("ButtonSubmit", {
              attrs: {
                loading: _vm.loading,
                disabled: _vm.loading,
                text: "inicia sesión"
              }
            }),
            _c("LinkForgottenPassword")
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-6 is-flex is-centered" }, [
      _c(
        "div",
        { staticClass: "content-container is-flex is-flex-direction-column" },
        [
          _c("p", { staticClass: "is-size-3" }, [
            _c("span", [
              _vm._v("Factura en línea "),
              _c("br"),
              _vm._v(" de manera")
            ]),
            _c(
              "span",
              { staticClass: "has-text-weight-bold has-text-izzi-cerise" },
              [_vm._v(" fácil y rápida "), _c("br")]
            ),
            _vm._v("\n        con "),
            _c("span", { staticClass: "has-text-weight-bold" }, [
              _vm._v("izzi factura digital")
            ])
          ]),
          _c("p", { staticClass: "is-size-5" }, [
            _vm._v(
              "\n        Emite tus facturas de manera ilimitada y haz crecer tu negocio.\n      "
            )
          ]),
          _c("img", {
            attrs: {
              src: require("../../assets/img/izzi/sign-in.png"),
              alt: "sign-in illustration"
            }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "sign-in-message" }, [
      _vm._v("\n          Inicia Sesión con tu cuenta "),
      _c("span", { staticClass: "has-text-weight-bold" }, [_vm._v("izzi")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }